import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "container py-5",
  style: {"min-height":"500px"}
}
const _hoisted_2 = { class: "text-h6" }
const _hoisted_3 = { class: "text-body-1" }
const _hoisted_4 = { key: 1 }

import { ref, onMounted, watch } from 'vue';
import { backendApi, AxiosError } from '@/http';
import { useGlobalStore, useConfigStore } from '@/stores';
import { useRoute } from 'vue-router';
import { $t } from '@/i18n';

// interfaces
import { ProjectImageType, ProjectType } from '@/composables/types';

// components
import PageTitle from '@/components/PageTitle.vue';

// images
import logoImageWithBackground from '@/assets/logo-with-bg.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectPage',
  setup(__props) {

const $route = useRoute();
const globalStore = useGlobalStore();
const configStore = useConfigStore();

const pageTitleRef = ref();
const showImage = ref(false);
const imageUrl = ref('');

const project = ref<ProjectType>({
  nameAr: '',
  nameEn: '',
  descriptionAr: '',
  descriptionEn: '',
  coverImage: '',
  projectImages: [] as ProjectImageType[],
} as ProjectType);

async function getProject() {
  try {
    const result = await backendApi.get(`projects/${$route.params['id']}`);
    project.value = result.data.data;
  } catch (error: unknown) {
    const message =
      error instanceof AxiosError && error.response?.data.message
        ? error.response.data.message
        : $t('FAILED_TO_LOAD_DATA');
    console.log(message);
    project.value = {} as ProjectType;
  }
}

onMounted(async () => {
  await getProject();
  globalStore.createVisit(
    $route.path,
    configStore.stringLang(project.value.nameAr, project.value.nameEn)
  );
  pageTitleRef.value.pageTitle = configStore.stringLang(
    project.value.nameAr,
    project.value.nameEn
  );
});

watch(
  () => $route.params['id'],
  async () => {
    await getProject();
    pageTitleRef.value.pageTitle = configStore.stringLang(
      project.value.nameAr,
      project.value.nameEn
    );
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_WebsiteLayout = _resolveComponent("WebsiteLayout")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WebsiteLayout, null, {
      content: _withCtx(() => [
        _createVNode(PageTitle, {
          ref_key: "pageTitleRef",
          ref: pageTitleRef,
          "page-title": _unref(configStore).stringLang(project.value.nameAr, project.value.nameEn)
        }, null, 8, ["page-title"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: 
                project.value.coverImage ??
                (project.value.partner && project.value.partner.logo
                  ? project.value.partner.logo
                  : _unref(logoImageWithBackground))
              ,
                    onClick: _cache[0] || (_cache[0] = 
                () => {
                  showImage.value = !showImage.value;
                  imageUrl.value =
                    project.value.coverImage ??
                    (project.value.partner && project.value.partner.logo
                      ? project.value.partner.logo
                      : _unref(logoImageWithBackground));
                }
              )
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "9"
              }, {
                default: _withCtx(() => [
                  (project.value.id)
                    ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { style: {"min-height":"200px"} }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(configStore).stringLang(project.value.nameAr, project.value.nameEn)), 1),
                              (project.value.partner)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: _normalizeClass(["text-subtitle-2", 
                    _unref(configStore).locale == 'ar'
                      ? 'post-description-right'
                      : 'post-description-left'
                  ])
                                  }, _toDisplayString(_unref(configStore).stringLang(
                      project.value.partner.nameAr,
                      project.value.partner.nameEn
                    )), 3))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(configStore).stringLang(
                      project.value.descriptionAr,
                      project.value.descriptionEn
                    )), 1),
                              (
                    project.value.projectImages && project.value.projectImages.length > 0
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_v_row, { class: "container py-5" }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.value.projectImages, (image, index) => {
                                          return (_openBlock(), _createBlock(_component_v_col, {
                                            key: index,
                                            cols: "12",
                                            md: "2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_img, {
                                                src: (image.imageLink as string),
                                                height: 150,
                                                "aspect-ratio": "1/1",
                                                cover: "",
                                                onClick: 
                          () => {
                            showImage.value = !showImage.value;
                            imageUrl.value = image.imageLink as string;
                          }
                        
                                              }, null, 8, ["src", "onClick"])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showImage.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showImage).value = $event)),
      class: "w-75 bg-white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, { src: imageUrl.value }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})